import { CheckListBarData, Modules, Stages } from "../../../contracts";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ReactElement } from "react";

export interface MainCheckListStageProps {
	readonly handleMainCheckListGuideChange: (
		checkedValue: CheckboxValueType[],
		isModuleCompleted: boolean
	) => void;
	readonly checkListBarData: CheckListBarData | null;
	readonly moduleOrder: Modules[];
}

export interface HighlightedCheckListStageProps {
	readonly checkListBarData: CheckListBarData | null;
	readonly moduleOrder: Modules[];
	readonly moduleStageMap?: Record<Modules, Stages[]>;
}

export interface ExploreCheckListStageProps {
	readonly activeGuide?: number;
	readonly checkListBarData: CheckListBarData | null;
	readonly moduleOrder: Modules[];
	readonly moduleStageMap?: Record<Modules, Stages[]>;
}

export interface CheckListBarOptions {
	readonly label: ReactElement | string;
	readonly value: string;
	readonly labelClass?: string;
}

export const ModuleClassMap: Record<Modules, string> = {
	[Modules.ALIGN]: "marketplace",
	[Modules.OPPORTUNITY]: "opportunities",
	[Modules.DOCUMENT]: "file",
	[Modules.INTEGRATION]: "integrations"
};

export interface CheckBoxLabelProps {
	readonly isLabelRequired: boolean;
	readonly moduleName: Modules;
	readonly isToolTipRequired?: boolean;
	readonly isTooltipVisible?: boolean;
	readonly handleTooltipClose?: () => void;
}
